import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

/**
 * 获取交易详情
 * @param {number} id - 交易ID
 * @returns {Promise}
 */
export const get_transaction_detail = (id) => {
  // 后端使用POST方法，参数从Body JSON传递
  return api.post(`${ApiEndpointConstants.GETTRANSACTIONDETAIL}`, { id });
};
